<template>
<div id="about">

<!-- Breadcrumbs -->
    <section class="city-breadcrumb"></section>
        <div class="row breadcrumb-box">
            <div class="mr-3 ml-5">
                <p class="mbr-text city-footer-font-bread display-7 ">
                    <a class="city-footer-link-sub" href="/">Home</a> > {{ title }}</p>
            </div>
        </div> 

<!-- Content -->
        <div class="container">
            <div class="row">
                <div class="card container-fluid ml-3">
                    <img class="card-img-top mt-3" id="card-img-base64">
                    <div class="card-body mb-5">
                        <h1 class="city-title mt-2 ">{{ title }}</h1>
                        <div class="large-city-green-div "></div>
                        <div>

        <p class="city-p">The Clean Bays Blueprint is a City of Corpus Christi Water Utilities program to protect public health and the water in our bays.</p>

            <p class="city-p">The City is proactively implementing strategies to improve our wastewater system.</p>

            <p class="city-p">Over the next 15 years, the City will continue to protect our environment and public health by implementing the Clean Bays Blueprint and related programs.<br><br></p>

            <h3 class="city-p"><strong>Guiding Principles:</strong></h3>

            <div class="container mb-5">
                <div class="row mt-2 mb-2">
                    <img style="float: left; width: 100px;" src="../index_files/images/guiding-principles-1.svg">
                            <ul class="city-p">
                                <h4 class="mt-3">Stewardship</h4>
                                    <ul>
                                        <li>Taking care of our financial investments and natural resources.</li>
                                    </ul>
                            </ul>
                </div>
                <div class="row mt-2 mb-2">
                    <img style="float: left; width: 100px;" src="../index_files/images/guiding-principles-2.svg">
                            <ul class="city-p">
                                <h4 class="mt-3">Empowerment</h4>
                                    <ul>
                                        <li>Giving the community the tools needed to protect our bays.</li>
                                    </ul>
                            </ul>
                </div>
                <div class="row mt-2 mb-2">
                    <img style="float: left; width: 100px;" src="../index_files/images/guiding-principles-3.svg">
                            <ul class="city-p">
                                <h4 class="mt-3">Transparency</h4>
                                    <ul>
                                        <li>Making information easy to understand and publicly available.</li>
                                    </ul>
                            </ul>
                </div>
                <div class="row mt-2 mb-2">
                    <img style="float: left; width: 100px;" src="../index_files/images/guiding-principles-4.svg">
                            <ul class="city-p">
                                <h4 class="mt-3">Investment</h4>
                                    <ul>
                                        <li>Committing to public health, public infrastructure and our bays.</li>
                                    </ul>
                            </ul>
                </div>
            </div>



            <h3 class="city-p mt-2"><strong>Resources:</strong></h3>

            <p class="city-p">Keeping our Bays clean requires collaboration. Check out what Solid Waste, Stormwater, the Oso Bay Wetland Preserve and Learning Center and regulatory agencies are doing to help.</p>

                    <ul class="city-p">
                        <li><a href="https://www.cctexas.com/sws">Solid Waste&nbsp;»</a></li>
                            <ul>
                                <li><a href="https://www.cctexas.com/services/trash-and-recycling/hazardous-waste-disposal">Household hazardous waste disposal&nbsp;»</a></li>
                                <li><a href="https://www.cctexas.com/solid-waste/community-cleanup-programs">Litter critter and community clean up&nbsp;»</a></li>
                            </ul>
                        <li><a href="https://www.cctexas.com/storm-water">Stormwater&nbsp;»</a></li>
                        <li><a href="https://www.cctexas.com/parks/services/general-government/oso-bay-wetlands-preserve-learning-center">Oso Bay Wetland Preserve&nbsp;»</a></li>
                        <li><a href="https://www.tceq.texas.gov/">Texas Commission on Environmental Quality&nbsp;»</a></li>
                        <li><a href="https://www.epa.gov/enforcement/city-corpus-christi-texas-clean-water-act-settlement">Environmental Protection Agency&nbsp;»</a></li>
                    </ul>

                    </div>
                </div> <!-- Content Here -->
            </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
  name: 'about',
  data () {
    return {
        title: 'About Clean Bays Blueprint',
        crumbLink:'',
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/About.vue